import { Dialog } from "@headlessui/react";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";
import { ModalFoterBox, ModalHeaderBox } from "../../components/box/Box";
import TableList, { GridCol, GridRow } from "../../components/table/TableList";

export type LoginInfoPdfDownloadValidateModalProp = {
    col: GridCol[];
    row: GridRow[];
};

export const LoginInfoPdfDownloadValidateModal = ({
  open,
  toggle,
  closeOnClickOutside,
  col,
  row
}: ModalProp & LoginInfoPdfDownloadValidateModalProp) => {
  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
        <form
            className=""
            method="POST"
            noValidate
        >
          <div className="px-2 pb-4 sm:p-4">
            <div className="text-center sm:mt-3">
              <ModalHeaderBox
                title={"ログイン情報PDFをダウンロードできません"}
              />
              <div className="text-left pl-5 mt-3">
                <div>
                    {`この利用者のログイン情報PDFをダウンロードできません。以下の項目をご確認ください。`}
                </div>
                <div className="mt-3">
                    <TableList footer={false} gridCol={col} gridRow={row} sort={false}/>
                </div>
              </div>
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mr-2"
              color={"indigo"}
              onClick={toggle}
              children={"OK"}
            />
          </ModalFoterBox>
        </form>
      </Dialog.Panel>
    </Modal>
  );
};
